import React from 'react';
import queryString from 'query-string';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import {config, MAX_FILE_SIZE, recaptcha_site_key } from '../config';
import { toast } from 'react-toastify';
import { getActiveItems } from '../service/ItemService';
import ClipLoader from "react-spinners/ClipLoader";
import { getUserId, getUserEmail } from '../service/UserService';
import SuccessfulReg from "../components/SuccessfulReg";
import ItemForDisplay from './ItemForDisplay';
import heic2any from "heic2any";

export default class ItemRegistration extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            item_id: -1,
            user_id: -1,
            description: "",
            usage_cultures: "",
            test_usage_size: "",
            test_usage_size_display: "",
            full_size: "",
            planned_date: "",
            location_county: "",
            location_city: "",
            location_number: "",
            accept1: false,
            captchaVerified: false,
            pickedItem: null,
            regFinished: false,
            errors:{},
            showList: false,
            file1: null,
            file2: null,
            file3: null,
            file1Preview: null,
            file2Preview: null,
            file3Preview: null,
            saving: false
		};

        this.inputFileRef1 = React.createRef();
        this.inputFileRef2 = React.createRef();
        this.inputFileRef3 = React.createRef();
    }
    
    componentDidMount(){
        const { termek } = queryString.parse(window.location.search);
        if(termek){
            getActiveItems().then(data => {
                let pickedItem = data.find(i => i.id === termek);
                this.setState({item_id: termek, pickedItem: pickedItem, user_id: getUserId()});    
            });
            
        }
        else if(this.props.itemId && this.props.itemId >= 0){
            this.setState({item_id: this.props.itemId, pickedItem: this.props.pickedItem});
        }
    }

    validateForm(){
        let errors = {};
        let formIsValid = true;
        
        /*if(!this.state.usage_cultures){
            formIsValid = false;
            errors["usage_cultures"] = "A mező kitöltése kötelező";
        }
        if(!this.state.full_size){
            formIsValid = false;
            errors["full_size"] = "A mező kitöltése kötelező";
        }
        if(!this.state.planned_date){
            formIsValid = false;
            errors["planned_date"] = "A mező kitöltése kötelező";
        }
        if(!this.state.location_county){
            formIsValid = false;
            errors["location_county"] = "A mező kitöltése kötelező";
        }
        if(!this.state.location_city){
            formIsValid = false;
            errors["location_city"] = "A mező kitöltése kötelező";
        }
        if(!this.state.location_number){
            formIsValid = false;
            errors["location_number"] = "A mező kitöltése kötelező";
        }*/
        this.setState({errors: errors});
        return formIsValid;
    }

    handleSubmitClick = (e) => {
        e.preventDefault();
        this.setState({saving: true});

        if(!this.validateForm()){
            return;
        }
        
        if(this.props.fullRegistration){
            this.props.handleSubmitClick(this.state);
            return;
        }
        else{
            this.saveNewItemRegistration();
        }
    }

    saveNewItemRegistration = () => {
        toast("Kísérlet regisztráció mentése", {type:'info'});
        let url = config.API_URL + '/Item/register.php';
        //console.log("calling url:" + url);
        let formDataObject = this.createFormData();
        axios({
            method: 'post',
            url: url,
            //headers: { 'content-type': 'application/json' },
            data: formDataObject
          })
          .then(result => {
            //console.log("result", result);
            if(result.data.status === true){
              //console.log("success");
              //toast("Sikeres regisztráció");
              this.props.history.push('/sikeresregisztracio?termek=' + this.state.item_id);
              //this.setState({regFinished: true});
            }
            else{
                alert("Hiba: " + result.data.message);
                this.setState({saving: false});
            } 
          })
          .catch(error => alert(error.message));
    }

    createFormData = () => {
        const formDataObject = new FormData();
        //formDataObject.append('token', getUserToken());
        formDataObject.append('data', JSON.stringify(this.state));
        if(this.state.file1) formDataObject.append('file1', this.state.file1, this.state.file1.name);
        if(this.state.file2) formDataObject.append('file2', this.state.file2, this.state.file2.name);
        if(this.state.file3) formDataObject.append('file3', this.state.file3, this.state.file3.name);

        return formDataObject;
    };

    handleBackClick = (e) => {
        if(this.props.fullRegistration){
            this.props.handleBackClick(e);
        }
        else{
            this.props.history.push("/fooldal");
        }
    }

    handleVerify = (token) =>{
        //console.log("recaptcha:", token);
        this.setState({captchaVerified: true});
    }

    onFileChange = (num, e) =>{
        let file = e.target.files[0];
        let extension = file.type;
        //console.log("trying to upload:"+ e.target.files[0].name + "|| " + extension, file);
       
        if(this.checkFileExtension(file.name.toString())){
            toast.error("Rossz fájltípus, csak PNG, JPG vagy HEIC elfogadott.");
            return;
        }
        else if(extension.indexOf("image/") < 0 && extension !== ""){
            toast.error("Rossz fájltípus");
            return;
        }
        if(file.size > MAX_FILE_SIZE){
            toast.error("Túl nagy méret. Fájl maximális mérete 3 MB lehet.");
            return;
        }
        if(e.target.files[0].name.toLowerCase().indexOf("heic") >= 0){
            this.convertHeic(file, num);
        }
        else{
            this.setState({
                ["file" + num]: e.target.files[0],
                ["file" + num +"Preview" ]: URL.createObjectURL(e.target.files[0])
            },
            ()=>{
                //console.log("newstate", this.state);
            }
            );
        }
    }
        
    async convertHeic(file, num) {
        const blob = await heic2any({ blob: file, toType: "image/jpeg" });
        let newsrc = (URL.createObjectURL(blob));
        //console.log("newsrc", newsrc);
        let newFilename = file.name.replace(".heic", ".jpg").replace(".HEIC", ".jpg");
        const convertedFile = new File([blob], newFilename, {
            type: "image/jpeg",
        });
        toast("Heic fájl sikeresen konvertálva.", {type:'warning'});
        this.setState({
            ["file" + num +"Preview" ]: newsrc,
            ["file" + num]: convertedFile,
        });
    }

    checkFileExtension(fileName) {
        return fileName.toLowerCase().indexOf("jpg") < 0 && 
                    fileName.toLowerCase().indexOf("jpeg") < 0 &&
                    fileName.toLowerCase().indexOf("heic") < 0 &&
                    fileName.toLowerCase().indexOf("png") < 0;
    }

    getTopImage(id){
        switch(id){
        case "1": return "nezzuk_kiserletek_thumbnail_web_leander.png"; 
        case "2": return "nezzuk_kiserletek_thumbnail_web_petrezselyem.png"; 
        case "3": return "nezzuk_kiserletek_thumbnail_web_tiszafa.png"; 
        case "4": return "nezzuk_kiserletek_thumbnail_web_foliassalata.png"; 
        case "5": return "nezzuk_kiserletek_thumbnail_web_srepa.png"; 
        case "6": return "nezzuk_kiserletek_thumbnail_web_leandervirag.png"; 
        case "7": return "nezzuk_kiserletek_thumbnail_web_fukomposzt.png"; 
        default: return "test";
        }
    }

    triggerFileChange(num){
        switch(num){
            case 1:this.inputFileRef1.current.click(); break;
            case 2:this.inputFileRef2.current.click(); break;
            case 3:this.inputFileRef3.current.click(); break;
            default: break;
        }       
    }

    calculateFileCount(){
        return (this.state.file1 ? 1:0) + (this.state.file2 ? 1:0) + (this.state.file3 ? 1:0) ;
    }

    render() {
        //let colorClass = (this.state.pickedItem) ? "kwizda-item-color-" + this.state.pickedItem.color.replace("#",""):"";
        
        return(
            <div style={{width:'100%', paddingBottom:!this.props.fullRegistration?30:0}}>
                {!this.props.fullRegistration? <h2 className="kwizda-page-title">Regisztráció további kísérletre</h2>:""}
                {(this.state.pickedItem && !this.state.regFinished)  ? 
                <div id="kwizda-itemreg" className="kwizda-form row" style={{width:'100%'}}>
                    <div className="kwizda-form-column col-xl-3 col-12 login-card mt-2 hv-center">
                        <div className="card">
                            <h4>Kiválasztott kísérlet</h4>
                            <ItemForDisplay item={this.state.pickedItem} loggedIn={false}
                                    isAdmin={false} ></ItemForDisplay>
                        </div>
                    </div>
                    <div className="kwizda-form-column col-xl-9 col-12 login-card mt-2 hv-center">
                        <div className="card">
                            <h4>Képek</h4>
                            <div className="kwizda-images-upload">
                                <div className="kwizda-images-upload-panel1">
                                    <div className="kwizda-images-title">Termesztési hely képe 1.</div>
                                    <div className="kwizda-images-desc">A kísérlet helye és/vagy a kísérletben résztvevő növény közelről</div>
                                    <div className="kwizda-images-image-preview">
                                        {this.state.file1Preview == null? 
                                            <div>
                                                <img alt="Nincs kép" src="img/kwzida3_ikonok/pic_upload_icon_01.png"></img><br/>
                                                Kép 1.
                                            </div>:
                                            <div>
                                                <img alt="Feltöltött kép 1" src={this.state.file1Preview}></img><br/>
                                                {this.state.file1?.name}
                                            </div>
                                        }
                                    </div>
                                    <div className="kwizda-images-upload-buttons">
                                        <input type="file" accept="image/*" onChange={(e) => this.onFileChange(1, e)} style={{width:'100%'}} ref={this.inputFileRef1}/>
                                        {this.state.file1 ?
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(1)}>Kép cseréje</span>:
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(1)}>Tallózás</span>
                                        }
                                    </div>
                                </div>
                                <div className="kwizda-images-upload-panel2">
                                    <div className="kwizda-images-title">Termesztési hely képe 2.</div>
                                    <div className="kwizda-images-desc">A kísérlet helye és/vagy a kísérletben résztvevő növény közvetlen környezetével együtt</div>
                                    <div className="kwizda-images-image-preview">
                                    {this.state.file2Preview == null? 
                                            <div>
                                                <img alt="Nincs kép" src="img/kwzida3_ikonok/pic_upload_icon_01.png"></img><br/>
                                                Kép 2.
                                            </div>:
                                            <div>
                                                <img alt="Feltöltött kép 2" src={this.state.file2Preview}></img><br/>
                                                {this.state.file2?.name}
                                            </div>
                                        }
                                    </div>
                                    <div className="kwizda-images-upload-buttons">
                                    <input type="file" accept="image/*" onChange={(e) => this.onFileChange(2, e)} style={{width:'100%'}} ref={this.inputFileRef2}/>
                                    {this.state.file2 ?
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(2)}>Kép cseréje</span>:
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(2)}>Tallózás</span>
                                        }
                                    </div>
                                </div>
                                <div className="kwizda-images-upload-panel3">
                                    <div className="kwizda-images-title">Termesztési hely képe 3.</div>
                                    <div className="kwizda-images-desc">A kísérletben szereplő kert nagyobb látószögben.</div> 
                                    <div className="kwizda-images-image-preview">
                                        {this.state.file3Preview == null? 
                                            <div>
                                                <img alt="Nincs kép" src="img/kwzida3_ikonok/pic_upload_icon_01.png"></img><br/>
                                                Kép 3.
                                            </div>:
                                            <div>
                                                <img alt="Feltöltött kép 3" src={this.state.file3Preview}></img><br/>
                                                {this.state.file3?.name}
                                            </div>
                                        }
                                    </div>
                                    <div className="kwizda-images-upload-buttons">
                                        <input type="file" accept="image/*" onChange={(e) => this.onFileChange(3, e)} style={{width:'100%'}} ref={this.inputFileRef3}/>
                                        {this.state.file3 ?
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(3)}>Kép cseréje</span>:
                                         <span style={{cursor:'pointer'}} onClick={() => this.triggerFileChange(3)}>Tallózás</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='kwizda-images-counter-div'>
                                <span className='kwizda-images-counter-div-numbers'>3/{this.calculateFileCount()} </span>
                                kép van feltöltve. Még {3-this.calculateFileCount()} kép feltöltése szükséges a regisztráció véglegesítéséhez.
                            </div>
                            <div style={{width:'100%', margiLeft: 'auto', marginRight: 0}}>
                                <h4>Adatvédelmi tájékoztató</h4>
                                <div className="kwizda-approve-container">
                                    <input type="checkbox" checked={this.state.accept1} 
                                    onChange={(e) => this.setState({accept1: e.target.checked})}></input>
                                    <span>
                                        Elfogadom a <a href={config.BASE_PATH + "/szabalyzat"} target="_blank" rel="noreferrer"> Részvételi feltételeket és az Adatvédelmi Tájékoztatót</a>
                                    </span>
                                </div>
                                <br/>
                                <div style={{marginTop:15}}>
                                    <ReCAPTCHA
                                        sitekey={recaptcha_site_key}
                                        onChange={(val) => this.handleVerify(val)}
                                    />
                                </div>
                            </div>
                            <div  className="kwizda-edit-form-buttons">
                                <button id="kwizda-endregister-button" 
                                    disabled={this.state.saving || !this.state.accept1 || !this.state.captchaVerified || !this.state.file1 || !this.state.file2 || !this.state.file3}
                                            type="submit" 
                                            className="kwizda-button"
                                            onClick={(e) => this.handleSubmitClick(e)}
                                >Regisztráció véglegesítése</button>
                                
                                <button style={{width:120, float: 'right', fontSize:14, borderRadius:0, marginLeft:10}} 
                                            disabled={this.state.saving}
                                            type="button" 
                                            className="kwizda-back-button"
                                            onClick={(e) => this.handleBackClick(e)}
                                >Vissza</button>
                                {this.state.saving && <div className='kwizda3-reg-saving'><ClipLoader loading={this.state.saving} size={40} /></div>}
                            </div>
                        </div>
                    </div>
                    
                </div>
                :""
                }
                
                {this.state.regFinished && 
                    <SuccessfulReg history={this.props.history} email={getUserEmail()}></SuccessfulReg>}
            </div>
        )
    }
}